import * as charts from "../../charts/";
import { ChartType } from "../../entities/reportEntity";

export default {
  id: 88,
  label: "主分类年度申请趋势分析",
  chart: charts.lineAndBar2D,
  definition: {
    rowDims: [{ name: "primaryIpc", label: "主分类", limit: 10, needTotal: true }],
    colDims: [{ name: "appDate", label: "申请年", dateUnit: "YEAR", limit: 10, needTotal: true }],
    measures: [{ name: "count", label: "专利量", sortBy: "DESC" }],
    showNoDataDims: true
  },
  chartOption: {
    chartType: ChartType.LINE,
    title: "主分类年度申请趋势分析",
    subTitle: "",
    hideTitle: false,
    xaxisTitle: "",
    yaxisTitle: "",
    hideAxisTitle: true,
    hideLabel: true,
    hideLegend: false,
    hideToolbox: false
  }
};
